import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ErrorHandler,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import {
  NgbDateAdapter,
  NgbDatepickerConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { HttpCacheInterceptorModule } from '@ngneat/cashew';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { TranslateModule } from '@ngx-translate/core';
import { NgChartsModule } from 'ng2-charts';
import { provideNgxMask } from 'ngx-mask';
import { EMPTY } from 'rxjs';
import { AuthService } from './services/auth.service';
import { DateAdapter } from './services/common/date-adapter.service';
import { ErrorService } from './services/common/error.service';
import { JWTInterceptor } from './services/interceptors';
import { TokenManager } from './services/tokens/token-manager';
import { MASK_CONFIG, TRANSLATE_CONFIG } from './utils/configs';
import { NGB_DATEPICKER_CONFIG } from './utils/constants';

@NgModule({
  imports: [
    HttpClientModule,
    NgChartsModule.forRoot(),
    TranslateModule.forRoot(TRANSLATE_CONFIG),
    HttpCacheInterceptorModule.forRoot(),
  ],
  exports: [HttpClientModule, TranslateModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() coreModule: CoreModule) {
    if (coreModule) {
      throw new Error(
        `CoreModule has already been loaded. Import CoreModule only once in the root AppModule.`
      );
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: (service: AuthService) => () =>
            TokenManager.get(TokenManager.TOKEN_ID)
              ? service.resolve().pipe()
              : EMPTY,
          deps: [AuthService],
          multi: true,
        },
        {
          provide: ErrorHandler,
          useClass: ErrorService,
        },
        {
          provide: NgbDateAdapter,
          useClass: DateAdapter,
        },
        {
          provide: NgbDatepickerConfig,
          useValue: NGB_DATEPICKER_CONFIG,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: JWTInterceptor,
          multi: true,
        },
        provideNgxMask(MASK_CONFIG),
        provideHotToastConfig({
          visibleToasts: 1,
          reverseOrder: true,
          dismissible: true,
          autoClose: true,
        }),
      ],
    };
  }
}
